/* eslint-disable import/prefer-default-export */

// TODO: have pretty alerts one day
export const responseError = ({ message }) => {
  window.console.error(message); // eslint-disable-line no-console
};

/* eslint-enable import/prefer-default-export */

export const isReportableCartError = error => {
  if (!error) return true;
  const status = error?.status;
  if (!status) return true;
  if (status >= 400 && status < 500) return false;
  return true;
};

/**
 * A custom error class that extends the built-in Error class and does not include a name prefix in the error message.
 */
export class PlainError extends Error {
  /**
   * Creates a new instance of the PlainError class with the specified error message.
   * @param {string} message - The error message.
   */
  constructor(message) {
    super(message);
    this.name = "";
  }
}
